var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChoiceTripsFeaturedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFF6D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 15.8333H18.5416M16.25 19.1667H18.5416M16.25 22.5H18.5416M21.4583 15.8333H23.75M21.4583 19.1667H23.75M21.4583 22.5H23.75M26.6666 27.5V15.1667C26.6666 14.2332 26.6666 13.7665 26.485 13.41C26.3252 13.0964 26.0702 12.8414 25.7566 12.6817C25.4001 12.5 24.9334 12.5 24 12.5H16C15.0665 12.5 14.5998 12.5 14.2433 12.6817C13.9297 12.8414 13.6747 13.0964 13.5149 13.41C13.3333 13.7665 13.3333 14.2332 13.3333 15.1667V27.5M28.3333 27.5H11.6666",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoiceTripsFeaturedIcon);
export default __webpack_public_path__ + "static/media/choice-trips-featured-icon.42e539b880dcd21515e8826759ff4a58.svg";
export { ForwardRef as ReactComponent };